var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "text-center",
      attrs: { icon: "" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.tab(_vm.ROUTER_NAME.MYPROFILE)
        },
      },
    },
    [
      _c("v-list-item-avatar", { staticClass: "ps-4" }, [
        _c("img", {
          staticStyle: { width: "25px", height: "25px" },
          attrs: {
            src:
              _vm.user && _vm.user.image
                ? _vm.user.image.url
                : "/assets/user-958851872d7a849ea34d9887d31e41ce820428c6fccef8cb62b595382379b407.png",
          },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }